import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService, IStorage, Kindergarten, LocalStorage } from '@isophi/core-legacy';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Subscription } from 'rxjs';

import { KindergartenService } from '../../../../core/services/kindergarten.service';

@Component({
    selector: 'app-workplace-selector',
    templateUrl: './workplace-selector.component.html',
    styleUrls: ['./workplace-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WorkplaceSelectorComponent implements OnInit, OnDestroy {
  kindergartens$ = new BehaviorSubject<Kindergarten[]>([]);

  currentKindergarten$ = new BehaviorSubject<Kindergarten | null>(null);

  isLoading = false;

  private _subs: Subscription[] = [];

  private localStorage: IStorage;

  constructor(
    private authService: AuthService,
    private kindergartenService: KindergartenService,
    private spinner: NgxSpinnerService,
    private cd: ChangeDetectorRef
  ) {
    this.localStorage = new LocalStorage();
  }

  get selectedKindergartenUUID(): string | null {
    return this.kindergartenService.getCurrentKindergartenUUID();
  }

  get currentKindergarten(): Kindergarten | null {
    return this.currentKindergarten$.value;
  }

  trackByKindergartenId(index: number, kindergarten: Kindergarten): number {
    return kindergarten.id;
  }

  ngOnInit(): void {
    this.loadKindergartens();
    this.loadCurrentKindergarten();
  }

  private loadKindergartens(): void {
    const teacher = this.authService.loggedUser?.teacher;
    if (!teacher) {
      return;
    }

    let kindergartens: Kindergarten[] = [];
    if (teacher.kindergartens && teacher.kindergartens.length > 0) {
      kindergartens = teacher.kindergartens;
    }

    this.kindergartens$.next(kindergartens);
    this.cd.markForCheck();
  }

  private loadCurrentKindergarten(): void {
    const current = this.kindergartenService.getCurrentKindergarten();
    this.currentKindergarten$.next(current);
    this.cd.markForCheck();
  }

  async onKindergartenSelect(kindergarten: Kindergarten): Promise<void> {
    const currentSelectedUUID = this.kindergartenService.getCurrentKindergartenUUID();
    if (kindergarten.uuid === currentSelectedUUID) {
      return; // already selected
    }

    localStorage.clear();
    this.kindergartenService.setSelectedKindergarten(kindergarten.uuid);
    this.authService.storeToken(this.localStorage);

    this.currentKindergarten$.next(kindergarten);
    window.location.reload();

    this.cd.markForCheck();
  }

  ngOnDestroy(): void {
    this._subs.forEach((sub) => sub.unsubscribe());
  }
}
